/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scope_LabelInputs */

const cs_scope_label = /** @type {(inputs: Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozsah`)
};

const en_scope_label = /** @type {(inputs: Scope_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scope`)
};

/**
* | output |
* | --- |
* | "Scope" |
*
* @param {Scope_LabelInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const scope_label = /** @type {((inputs?: Scope_LabelInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scope_LabelInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_scope_label(inputs)
	return cs_scope_label(inputs)
});